import RadialProgress from "@components/Progress/RadialProgress";
import { getUsername } from "@utils/utilities";
import { User } from "firebase/auth";
import React, { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { twMerge } from "tailwind-merge";
import { ReactComponent as CheckIcon } from "../../assets/icons/checked.svg";
import BarStepsProgress from "@components/Progress/BarStepsProgress";
import { DocumentData } from "firebase/firestore";

type DashboardFactFindProps = {
  questionnaireData: {
    fact_find_completed: boolean;
    fact_find_percentage: number;
    next_fact_find_step: string;
  };
  userData: {
    userData: DocumentData | null | undefined;
    userAuth: User | null | undefined;
  };
};

const DashboardFactFind: React.FC<DashboardFactFindProps> = ({
  questionnaireData,
  userData,
}) => {
  const navigate = useNavigate();
  const goToFactFind = () => {
    if (userData?.userData?.form_qualification) {
      navigate("/fact-find");
    } else {
      navigate("/fact-find/welcome");
    }
  };

  const username = useMemo(() => {
    return getUsername(userData.userAuth, userData.userData, true);
  }, [userData.userAuth, userData.userData]);

  return (
    <>
      <div className="px-4 pb-6 lg:px-[80px] md:py-10 bg-pn_paper-3 flex flex-col gap-y-0 md:gap-y-6">
        <div className="p-4 md:p-0">
          <BarStepsProgress activeStep={1} />
        </div>

        <div
          className={twMerge(
            `border bg-white border-pn_gray-200 rounded-xl p-6`,
            questionnaireData.fact_find_completed
              ? `flex gap-x-4`
              : `flex flex-col md:flex-row items-start gap-y-6 md:gap-y-0 md:items-center gap-x-2`
          )}
        >
          <div className="flex flex-col md:flex-row items-start md:items-center gap-y-4 md:gap-y-0 gap-x-6 flex-1">
            {questionnaireData.fact_find_completed ? (
              <div className="w-10 h-10 rounded-full bg-pn_green-500 flex items-center justify-center">
                <CheckIcon />
              </div>
            ) : (
              <RadialProgress
                percentage={questionnaireData.fact_find_percentage}
              />
            )}

            <div className="flex-col flex flex-1 gap-y-1">
              <span className="text-pn-body-emphasis text-pn_gray-950">
                {questionnaireData.fact_find_completed
                  ? "Fact Find Complete"
                  : "Start Deep Fact Find"}
              </span>
              <span className="text-pn-callout-regular text-pn_gray-600">
                {questionnaireData.fact_find_completed
                  ? username
                    ? `${username}, in the next ~24 hours, we will have a tailored pension recommendation for you. We will email you once ready.`
                    : `In the next ~24 hours, we will have a tailored pension recommendation for you. We will email you once ready.`
                  : username
                    ? `${username}, answering these questions will help you get the most out of a call with your adviser.`
                    : `Answering these questions will help you get the most out of a call with your adviser.`}
              </span>
            </div>
          </div>

          {!questionnaireData.fact_find_completed && (
            <button
              className="btn-primary-sm-40 w-full md:w-auto"
              onClick={goToFactFind}
            >
              {questionnaireData.fact_find_percentage > 0
                ? "Continue"
                : "Get Started"}
            </button>
          )}
        </div>
      </div>
    </>
  );
};
export default DashboardFactFind;
